import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PROPERTIES } from 'utils/constants';
import styled from 'styled-components';
import { addPropertyImagePrefix } from 'utils/images';
import { fadeInDown, fadeOutUp } from 'react-animations';
import { prop } from 'styled-tools';

const StyledPropertyItem = styled.a`
  display: block;
  background: none;
  border: 0;
  border-radius: 0;
  width: 100%;
  text-align: left;
  padding: 1em;
  cursor: pointer;
  color: #ffffff;

  &:focus {
    box-shadow: ${props => props.theme.forms.input.focusOutline};
  }

  // Using this trick to work around issue with specificity, to avoid using !important.
  // https://www.styled-components.com/docs/advanced#issues-with-specificity
  && {
    text-decoration: none;
  }

  .fa-caret-down {
    margin-left: 0.25em;
    display: none;
  }

  strong {
    display: none;
  }

  &.selected {
    padding-top: 0.5em;
    padding-bottom: 0.5em;

    .fa-caret-down {
      display: inline-block;
    }

    strong {
      display: inline;
    }
  }

  strong,
  h1 {
    color: #fff;
    margin: 0;
  }

  img {
    width: 100%;
  }

  &.atmore {
    background: url(${addPropertyImagePrefix('atmore/Atmore-select.png')}) top
      right no-repeat;
    background-size: cover;
  }

  &.montgomery {
    background: url(${addPropertyImagePrefix(
        'montgomery/Montgomery-select.png'
      )})
      top left no-repeat;
    background-size: cover;
  }

  &.wetumpka {
    background: url(${addPropertyImagePrefix('wetumpka/Wetumpka-select.png')})
      top right no-repeat;
    background-size: cover;
  }

  &.chicago {
    background: url(${addPropertyImagePrefix('wetumpka/Wetumpka-select.png')})
      top right no-repeat;
    background-size: cover;
  }

  &.bethlehem {
    background: url(${addPropertyImagePrefix('bethlehem/Bethlehem-select.png')})
      top right no-repeat;
    background-size: cover;
  }

  &.open {
    animation: scale-display ${props => props.timeouts}ms;
    display: block;
  }

  &.noopen {
    animation: scale-display--reversed ${props => props.timeouts}ms;
    animation-fill-mode: forwards;
  }

  &.hidden {
    display: none;
  }

  @media screen and (max-width: ${prop('theme.breakpoints.medium')}) {
    max-height: 10rem;
  }

  @keyframes in-animation {
    ${fadeInDown};
  }

  @keyframes scale-display--reversed {
    0% {
      display: block;
      opacity: 1;
      height: 100%;
      transform: scale(1);
      -webkit-transform: scale(1);
    }
    100% {
      transform: scale(0);
      -webkit-transform: scale(0);
      display: none;
    }
  }
`;

class PropertyItem extends Component {
  handleClick = () => {
    const { value, onClick } = this.props;

    if (onClick) {
      onClick(value);
    }
  };

  handleKeyDown = event => {
    const { value, onClick } = this.props;

    if (onClick && (event.key === 'Enter' || event.key === ' ')) {
      onClick(value);
    }
  };

  render() {
    const {
      value,
      href,
      isSelected,
      isOpen,
      noDisplay,
      timeouts,
      itemProps = {}
    } = this.props;

    return (
      <StyledPropertyItem
        className={`property-item ${value} 
        ${isSelected ? 'selected' : ''} 
        ${value}
        ${isOpen ? 'open' : 'noopen'}
        ${noDisplay ? 'hidden' : ''}
        `}
        href={href}
        target={href ? '_blank' : undefined}
        onClick={this.handleClick}
        onKeyDown={this.handleKeyDown}
        aria-label={`View rates and availability for Wind Creek ${PROPERTIES[value]}`}
        tabIndex="0"
        timeouts={timeouts}
        {...itemProps}
      >
        {isSelected && (
          <strong id="selectPropertyLabel">SELECT PROPERTY</strong>
        )}
        <h1 id={`propertySelect_${value}`}>
          {PROPERTIES[value]}
          <FontAwesomeIcon
            icon="caret-down"
            aria-hidden="true"
            role="presentation"
          />
        </h1>
      </StyledPropertyItem>
    );
  }
}

PropertyItem.propTypes = {
  value: PropTypes.string,
  href: PropTypes.string,
  onClick: PropTypes.func,
  isSelected: PropTypes.bool,
  isOpen: PropTypes.bool,
  noDisplay: PropTypes.bool,
  timeouts: PropTypes.number
};

export default PropertyItem;
